import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const DJIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="DJ" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#73BE4A"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#69F"
          fillRule="evenodd"
          d="M0-1v7h16v-7H0Z"
          clipRule="evenodd"
        />
      </G>
      <Path
        fill="#fff"
        fillRule="evenodd"
        d="M0 0v12l9-6-9-6Z"
        clipRule="evenodd"
      />
      <Mask
        id="c"
        width={9}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12l9-6-9-6Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#c)">
        <Path
          fill="#E31D1C"
          fillRule="evenodd"
          d="m3.5 7.035-.934.565.213-1.102L2 5.674l1.055-.045L3.5 4.6l.446 1.029H5l-.777.87.234 1.101-.956-.565Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
